// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"8c92f9f9","88":"71b4f094","125":"fd7a24f7","232":"c63cd4ba","310":"636941ca","942":"1efd8509"}[chunkId] + ".chunk.js";
};